<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>学习汇报</el-breadcrumb-item>
  <el-breadcrumb-item>雅思申报列表</el-breadcrumb-item>
</el-breadcrumb>
<el-card>

  <el-row typeof="flex"  align="middle" justify="space-between">
    <el-col :span="2">
      <el-select v-model="Score" placeholder="分数查询" @keyup.enter.native="VileaDate">
      <el-option label="listening" value="listening"></el-option>
      <el-option label="reading" value="reading"></el-option>
      <el-option label="speaking" value="speaking"></el-option>
      <el-option label="writing" value="writing"></el-option>
      <el-option label="总分" value="overBandScore"></el-option>
      <el-option label="全部" value=""></el-option>
    </el-select></el-col>
  <el-col :span="1"><el-input v-model="Score1" @keyup.enter.native="VileaDate"></el-input></el-col>
  <el-col :span="1"><p class="lableforP" >~~</p></el-col>
  <el-col :span="1"><el-input v-model="Score2" @keyup.enter.native="VileaDate"></el-input></el-col>
  <el-col :span="2"><p class="lableforP" >考试时间：</p></el-col>
  <el-col :span="3"> 
    <el-select v-model="times" placeholder="所有时间" @keyup.enter.native="VileaDate">
      <el-option label="所有时间" value=""></el-option>
      <el-option :label="ielts" :value="ielts" v-for="(ielts,index) in datatime" :key="index"></el-option>
    </el-select>
  </el-col>
  <el-col :span="2"><p class="lableforP" >考试形式：</p></el-col>
  <el-col :span="3"> 
    <el-select v-model="examType" placeholder="全部形式" @keyup.enter.native="VileaDate">
      <el-option label="机考" value="机考"></el-option>
      <el-option label="纸考" value="纸考"></el-option>
      <el-option label="全部形式" value=""></el-option>
    </el-select>
  </el-col>
  <el-col :span="1"><p class="lableforP" >学号：</p></el-col>
  <el-col :span="2">
    <el-input v-model="studentId" @keyup.enter.native="VileaDate"></el-input>
  </el-col>
  <el-col :span="2"><el-button type="primary" @click="VileaDate">查询</el-button></el-col>
      <el-col :span="3"> <p class="lableforSearch">查询到{{ieltsList.length}}条数据</p></el-col>

</el-row>


 <el-table
    ref="multipleTable"
    :data="ieltsList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
     @selection-change="handleSelectionChange">
    <el-table-column
      type="selection" 
      width="40">
    </el-table-column>
    <el-table-column
      prop="studentID"
      :show-overflow-tooltip="true"
      label="学号"
      width="110">
    </el-table-column>
     <el-table-column
      prop="listening"
      :show-overflow-tooltip="true"
      label="listening"
      width="100">
    </el-table-column>

     <el-table-column
      prop="reading"
      label="reading"
      width="100">
    </el-table-column>
     <el-table-column
      prop="writing"
      label="writing"
      width="100">
    </el-table-column>
     <el-table-column
      prop="speaking"
      label="speaking"
      :show-overflow-tooltip="true"
      width="100">
    </el-table-column>
     <el-table-column
      prop="overBandScore"
      label="overBandScore"
      :show-overflow-tooltip="true"
      width="150">
    </el-table-column>
     <el-table-column
      prop="cefrlevel"
      label="CEFRlevel"
      width="100">
    </el-table-column>
     <el-table-column
      prop="examTime"
      label="考试时间"
      width="120">
    </el-table-column>
    <el-table-column
      prop="ukvinumber"
      label="UKVINumber"
      width="120">
    </el-table-column>
         <el-table-column
      prop="examAddress"
      label="考试地点"
      :show-overflow-tooltip="true"
      width="180">
    </el-table-column>
            <el-table-column
      prop="subTime"
      label="信息提交时间"
      :show-overflow-tooltip="true"
      width="130">
    </el-table-column>
     <el-table-column
      prop="examType"
      label="考试形式"
      width="100">
    </el-table-column>
     <el-table-column
      label="操作"
      width="100">
        <template  slot-scope="scope">
<el-button   @click="showPdf(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-chakan2"></use></svg></el-button>
      </template>
    </el-table-column>
  </el-table>
 <div style="margin-top: 20px">
    <el-button @click="selectDatas">导出Excel</el-button>
    <el-button @click="toggleSelection()">取消选择</el-button>
  </div>
</el-card>
<el-dialog
  title="选择导出内容"
  :visible.sync="selectData"
  width="50%">
  <el-form :model="ruleForm"  label-width="100px" class="demo-ruleForm">
    <el-form-item label="列表" prop="type">
    <el-checkbox-group v-model="ruleForm.type">
      <el-checkbox label="学号"  name="type"></el-checkbox>
      <el-checkbox label="listening" name="type"></el-checkbox>
      <el-checkbox label="reading" name="type"></el-checkbox>
      <el-checkbox label="writing" name="type"></el-checkbox>
      <el-checkbox label="speaking" name="type"></el-checkbox>
      <el-checkbox label="overBandScore" name="type"></el-checkbox>
      <el-checkbox label="cefrlevel" name="type">CEFRlevel</el-checkbox>
      <el-checkbox label="examTime" name="type">考试时间</el-checkbox>
      <el-checkbox label="examAddress" name="type">考试地址</el-checkbox>
      <el-checkbox label="subTime" name="subTime">信息提交时间</el-checkbox>
      <el-checkbox label="examType" name="type">考试形式</el-checkbox>
    </el-checkbox-group>
  </el-form-item>
  </el-form>
  <el-button @click="exportExcel()">确认</el-button>
</el-dialog>
<el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="70%">
  <pdf
    :src="$imagepath+pdfpath"
    >
  </pdf>

  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
   
  </span>
</el-dialog>

  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
   components:{
      pdf
  },
created(){
  this.getIelts()
},
data(){
  return{
  ieltsList:[],
  ieltsListText:[],
   multipleSelection: [],
   datatime:[],
   times:'',
   examType:'',
   dialogVisible:false,
   selectData:false,
   imagepath:'',
   pdfpath:'',
   Score:'',
   Score1:'',
   Score2:'',
   studentId:'',
   ruleForm:{
    type:['学号', 'listening', 'reading', 'examTime', 'writing', 'examAddress', 'speaking', 'subTime', 'examType', 'overBandScore', 'cefrlevel']
   },
  }
},
methods:{
  getIelts(){
     this.imagepath=this.$imagepath
    this.axios.post("/ielts/getIeltsById")
        .then((resp) => {
          if (resp.data.status == 1) {console.log(resp.data.result)
            this.ieltsList=resp.data.result
        for(var i=0;i<this.ieltsList.length;i++){
        if(this.datatime.includes(this.ieltsList[i].examTime)){
        }else{
          this.datatime.push(this.ieltsList[i].examTime)
        }    
      }
      console.log(this.datatime)
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });     
  }, 
   handleSelectionChange(val) {
        this.multipleSelection = val;
      },
       toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },showPdf(data){
        this.pdfpath=data.filePath
        this.dialogVisible=true
      },
      exportExcel() {
if(this.ruleForm.type.length==0){
          this.$message.error("请选择导出")
          return
        }
        const formData = new FormData()
          this.multipleSelection.forEach((value, index) => {
            formData.append(`ieltsList[${index}].CEFRLevel`, value.cefrlevel)
            formData.append(`ieltsList[${index}].excelData`, value.examTime)
            formData.append(`ieltsList[${index}].examType`, value.examType)
            formData.append(`ieltsList[${index}].overBandScore`, value.overBandScore)
            formData.append(`ieltsList[${index}].listening`, value.listening)
            formData.append(`ieltsList[${index}].reading`, value.reading)
            formData.append(`ieltsList[${index}].speaking`, value.speaking)
            formData.append(`ieltsList[${index}].studentID`, value.studentID)
            formData.append(`ieltsList[${index}].writing`, value.writing)
            formData.append(`ieltsList[${index}].examAddress`, value.examAddress)
            formData.append(`ieltsList[${index}].excelsubTime`, value.subTime)
})

formData.append('type',this.ruleForm.type)
      this.axios({
        url: "/ielts/exportExcel",   //后端地址
        method: "post",
        data:formData, //请求参数
        headers: {  
        'Access-Control-Allow-origin': '*', 'Content-Type': 'application/json; charset=UTF-8',
        },
        // contenType:'application/json',
        responseType: "blob"
      })
        .then(res => {
          const blob = new Blob([res.data], { type: 'xlsx' });
          const fileName = "数据报表.xlsx"; 
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink); 
            this.selectData=false
        })
    },selectDatas(){
        
      if(this.multipleSelection.length===0){
          this.$message.error("请选择导出列表")
          return
        }
          this.selectData=true
        },
        
        VileaDate(){
          if( this.ieltsListText.length==0){
            this.ieltsListText=this.ieltsList
          }
          if(this.Score1==''){this.Score1=0}
          if(this.Score2==''){this.Score2=100}
          this.ieltsList=this.ieltsListText.filter((item)=>{
            if(this.Score==''){
              return true
            }else if(this.Score=='listening'){
          return  this.Score1<= item.listening&item.listening <=this.Score2
        }else if(this.Score=='reading'){
          return  this.Score1<= item.reading&item.reading <=this.Score2
        }else if(this.Score=='speaking'){
          return  this.Score1<= item.speaking&item.speaking <=this.Score2
        }else if(this.Score=='writing'){
          return  this.Score1<= item.writing&item.writing <=this.Score2
        }else if(this.Score=='overBandScore'){
          return  this.Score1<= item.overBandScore&item.overBandScore <=this.Score2
        }
          })

          this.ieltsList=this.ieltsListText.filter((item)=>{
            if(this.Score==''){
              return true
            }else if(this.Score=='listening'){
          return  this.Score1<= item.listening&item.listening <=this.Score2
        }else if(this.Score=='reading'){
          return  this.Score1<= item.reading&item.reading <=this.Score2
        }else if(this.Score=='speaking'){
          return  this.Score1<= item.speaking&item.speaking <=this.Score2
        }else if(this.Score=='writing'){
          return  this.Score1<= item.writing&item.writing <=this.Score2
        }else if(this.Score=='overBandScore'){
          return  this.Score1<= item.overBandScore&item.overBandScore <=this.Score2
        }
          })
        this.ieltsList=this.ieltsList.filter((item)=>{
          if(this.times!=''){
            return this.times==item.examTime
          }else{
            return true
          }      
        })

        this.ieltsList=this.ieltsList.filter((item)=>{
          if(this.examType!=''){
            return this.examType==item.examType
          }else{
            return true
          }      
        })
        this.ieltsList=this.ieltsList.filter((item)=>{
          if(this.studentId!=''){
            return item.studentID.includes(this.studentId)
          }else{
            return true
          }      
        })

        }
}
}
</script>

<style scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
  .lableforP{
      margin-top:8px;
}

  .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/bam/ViewStudentIelts.vue